import Login from "../features/auth/routes/login";
import { APP_ROUTES } from "../lib/constants/appRoutes";

export const publicRoutes = [
  { path: APP_ROUTES.LOGIN, element: <Login /> },
];

export default publicRoutes;